import { Grid } from '@mui/material';
import Card from '../../components/Card/Card';
import CardHeader from '../../components/Card/CardHeader';
import CardBody from '../../components/Card/CardBody';
import { SettingsButton } from '../Profile/ShipperSettings';
import { DeveloperBoard, ListAlt, Receipt } from '@material-ui/icons';

export default function InventoryManagement() {
  return (
    <Card>
      <CardHeader color="primary">
        <Grid container p={0} m={0} alignItems="center">
          <Grid item flexGrow={1}>
            <span>Inventory Management</span>
          </Grid>
        </Grid>
      </CardHeader>
      <CardBody>
        <SettingsButton
          caption="Assembly Builds"
          href="/inventory-management/assembly-builds"
          svgIcon={DeveloperBoard}
        />
        <SettingsButton caption="Item Receipts" href="/inventory-management/item-receipts" svgIcon={Receipt} />
        <SettingsButton caption="Inventory Count" href="/inventory-management/inventory-count" svgIcon={ListAlt} />
      </CardBody>
    </Card>
  );
}
